import type { ReactNode } from "react";

import { AviaryProvider } from "@aviary/utils";
import { Router } from "@shared/components";
import {
  GlobalContextProvider as SharedGlobalContextProvider,
  GlobalContextUserRole,
  ExperimentProvider,
} from "@shared/context";
import { GlobalContextProvider } from "@unauthenticated/shared/context";

import { ApolloClientProvider } from "./ApolloClientProvider";

interface Props {
  emailRegex: string;
  country: string;
  treatmentPlanTerm: string;
  children: ReactNode;
  analyticsAnonymousId: string;
}

const Providers = ({
  emailRegex,
  country,
  treatmentPlanTerm,
  children,
  analyticsAnonymousId,
}: Props) => {
  return (
    <ApolloClientProvider>
      <Router>
        <SharedGlobalContextProvider
          country={country}
          role={GlobalContextUserRole.UNAUTHENTICATED}
          e2e={false}
        >
          <GlobalContextProvider
            emailRegexString={emailRegex}
            treatmentPlanTerm={treatmentPlanTerm}
          >
            <AviaryProvider isWhiteBackground>
              <ExperimentProvider value={{ analyticsAnonymousId }}>{children}</ExperimentProvider>
            </AviaryProvider>
          </GlobalContextProvider>
        </SharedGlobalContextProvider>
      </Router>
    </ApolloClientProvider>
  );
};

export { Providers };
